export const acquisitionTypeColors = {
  purchase: '#6185DB',
  consignment: '#FAD901',
}
